import { useLazyGetKnowledgeBaseCollectorsQuery } from 'src/services/knowledgeBaseService';
import { useAuthorizationPolling } from 'src/hooks/useAuthorizationPolling';
import type { KnowledgeBaseCollector } from 'src/services/knowledgeBaseService';

// Waits for a knowledge base collector's Zendesk OAuth consent after its consent page is opened.
export const useZendeskAuthorizationPolling = (kbId: number | string) => {
  const [getCollectors] = useLazyGetKnowledgeBaseCollectorsQuery();
  const { isCheckingAuthStatus, pollAuthorization } = useAuthorizationPolling();

  // Polls the knowledge base collectors until the collector's auth_status is "ok", then passes it
  // to `onAuthorized`.
  const pollZendeskAuthorization = (
    collectorId: string,
    onAuthorized: (authorizedCollector: KnowledgeBaseCollector) => void,
  ) =>
    pollAuthorization(async () => {
      const { data: collectors } = await getCollectors({ id: kbId, include_data: true });
      const collector = collectors?.find(({ id }) => id === collectorId);

      return collector?.auth_status === 'ok' ? collector : null;
    }, onAuthorized);

  return { isCheckingAuthStatus, pollZendeskAuthorization };
};
